/** `REGEX.EMAIL` 과 동일 (이름·도메인·최상위 도메인 필요). */
const EMAIL_REGEX =
  /^[a-zA-Z0-9+._%-]{1,256}@[a-zA-Z0-9][a-zA-Z0-9-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9-]{0,25})+$/;

export const validateEmail = (value: string): string | undefined => {
  if (value.length === 0) return '이메일을 입력해주세요';
  if (!EMAIL_REGEX.test(value)) return '이메일 형식이 잘못되었어요';
  return undefined;
};

export const validateLoginPassword = (value: string): string | undefined => {
  // 8자 미만 레거시 비번 계정을 막을 위험이 있어 required만 검증
  if (value.length === 0) return '비밀번호를 입력해주세요';
  return undefined;
};
